import { StatSourceService } from './services/stat-source.service';
import { TriggerService } from './services/trigger.service';
import { Observable, ReplaySubject, Subscription } from 'rxjs';
import { AgentStatIndicator, Source } from './models/agent-stat.model';
import { SourceTypes, TriggerTypes } from './agent-stat.config';

export class AgentStatObject {
  private _newStatValueObservable = new ReplaySubject(1);
  private _source: Source;
  private _triggers = [];
  private _sourceSubscription: Subscription;

  constructor(private _sourceService: StatSourceService,
              private _triggerService: TriggerService) {
  }

  get newStatValue$(): Observable<any> {
    return this._newStatValueObservable.asObservable();
  }

  public addTriggers(triggers: TriggerTypes[]): void {
    triggers.forEach(async (trigger) => {
      const newTrigger = await this._triggerService.addTriggerForSource(trigger);
      newTrigger.refreshTargets.push(this._source);
      this._triggers.push(newTrigger);
    });
  }

  async setSource(source: SourceTypes, indicator: AgentStatIndicator): Promise<Source> {
    this._source = await this._sourceService.getSource(source, indicator);
    this._sourceSubscription = this._source.obs.subscribe((newValue) => {
      if (newValue) {
        this._newStatValueObservable.next(newValue);
      }
    });
    return this._source;
  }

  public cleanUp(): void {
    this._triggers.forEach(trigger => {
      const foundIdx = trigger.refreshTargets.indexOf(this._source);
      if (foundIdx !== -1) {
        trigger.refreshTargets.splice(foundIdx, 1);
      }
    });
    if (this._sourceSubscription) {
      this._sourceSubscription.unsubscribe();
    }
    this._newStatValueObservable.complete();
    this._newStatValueObservable = null;
    this._triggers = null;
    this._source = null;
  }
}
